import { state as getDefaultState } from "./index"
import { getDestinationResource } from "../../helpers/string"

export default {
  setLang(state, val) {
    state.lang = val
  },

  setIsContestClosed(state, val) {
    state.isContestClosed = val
  },

  setAppDomain(state, val) {
    state.appDomain = val
  },

  setDestinations(state, val) {
    state.destinations = val
  },

  setSelectedDestination(state, val) {
    state.selectedDestination = val
  },

  setUser(state, val) {
    state.user = val
  },

  setUTMs(state, newUtms) {
    // remove empty values
    Object.keys(newUtms).forEach(
      key => newUtms[key] == null && delete newUtms[key]
    )
    state.utms = Object.assign({}, state.utms, newUtms)
  },

  setUserDestination(state, destinationId) {
    state.user = Object.assign({}, state.user, {
      destination: getDestinationResource(destinationId)
    })
  },

  addSentInvitation(state, invitation) {
    state.sentInvitations = Object.assign({}, state.sentInvitations, {
      [invitation.id]: invitation
    })
  },

  setSentInvitations(state, val) {
    state.sentInvitations = val
  },

  resetState(state) {
    const s = getDefaultState()
    Object.keys(state).forEach(key => {
      state[key] = s[key]
    })
  }
}
